// extracted by mini-css-extract-plugin
export var box = "_5j-1";
export var checkboxRow = "_5j-8";
export var checked = "_5j-2";
export var descriptionSpacer = "_5j-a";
export var disabled = "_5j-3";
export var icon = "_5j-6";
export var input = "_5j-0";
export var labelSpacer = "_5j-9";
export var medium = "_5j-5";
export var small = "_5j-4";
export var text = "_5j-7";